import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import useModal from "@/app/lib/features/modal/modal.hook";
import Image from "next/image";
import { Loader2 } from "lucide-react";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const ImageOverlays = () => {
  const { product, fetchModalContentIfNeeded, isModalLoading } = useProductDetail();
  const { createModal } = useModal();

  if (!product) return null;

  const combineButton = product.combine;

  if (!combineButton) {
    return null;
  }

  const handleCombineClick = async () => {
    if (!product.id || isModalLoading) return;

    const success = await fetchModalContentIfNeeded(product.id, "combine");

    if (success) {
      trackGeneric("combine_outfit", "click");
      createModal("outfit-complete", { mainProduct: product });
    }
  };

  return (
    <div className="absolute bottom-2 left-2 z-50 flex flex-col gap-2">
      <button
        type="button"
        onClick={handleCombineClick}
        disabled={isModalLoading}
        className="cursor-pointer px-2 py-1 rounded-md backdrop-blur-sm text-xs font-medium flex items-center gap-1 disabled:opacity-50"
        style={{
          backgroundColor: combineButton.button_background,
          color: combineButton.button_text_color,
        }}
      >
        {isModalLoading ? (
          <Loader2 className="w-3 h-3 animate-spin" />
        ) : (
          combineButton.icon && (
            <Image
              src={combineButton.icon}
              alt={combineButton.button_text}
              width={12}
              height={12}
            />
          )
        )}
        <span>{combineButton.button_text}</span>
      </button>
    </div>
  );
};

export default ImageOverlays;